<template>
  <div>
    <NewHospital></NewHospital>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const NewHospital = defineAsyncComponent(() =>
  import("@/components/hospitals/NewHospital")
);
export default {
  components: {
    NewHospital,
  },
};
</script>
